import {
    useEffect,
    useState
} from 'react';
import { Platform } from 'react-native';

import actions, { back } from '../../actions';
import { AppHeader } from '../../combo';
import { ImageSlider } from '../../combo/ImageSlider';
import {
    LoadingIndicator,
    Page,
    React,
    View
} from '../../common';
import { getDocuments } from '../../selectors';
import { resolveImagePath } from '../../services/device';
import {
    checkUrls,
    checkUrlsAndroid
} from '../Visits/VisitImagesSlider';

export const DocumentsSlider = Page.register(
    ({
        documents: data = [],
        initialId,
        setState,
        // isUpdating: upd,
    }) => {
        const [ dataUrls, setDataUrls ] = useState([]);
        // const [currentItemId, setCurrentItemId] = useState(initialId);
        const [ isUpdating, setIsUpdating ] = useState(true);

        useEffect(() => {
            const urls = data.map((item) => ({
                ...item,
                url: resolveImagePath(item.uri, item.cachePath || item.path),
            }));
            const fn = Platform.OS === 'ios' ? checkUrls : checkUrlsAndroid;
            fn(urls, true)
                .then((u) => {
                    setDataUrls(u);
                })
                .catch(() => {
                    setDataUrls([]);
                })
                .finally(() => setTimeout(() => setIsUpdating(false), 0));
            // } else {
            //     setDataUrls(urls);
            //     setIsUpdating(false);
            // }
        }, [ data, initialId ]);


        return (
            <Page
                backgroundColor="black"
                noscroll
                safeArea
            >
                <View
                    style={{
                        flex: 1,
                        backgroundColor: 'black',
                    }}
                >
                    {!isUpdating ? (
                        <ImageSlider
                            initialId={initialId}
                            dataUrls={dataUrls}
                            onDelete={async (itemId) => {
                                // setState({ isUpdating: true });
                                setIsUpdating(true);
                                const newData = dataUrls?.filter?.(({ id }) => id !== itemId);
                                await actions.removeDocument(itemId);
                                // setState({ dataUrls: newData });
                                setDataUrls(newData);
                                if (!newData.length) {
                                    back();
                                } else {
                                    const currentItemIndex = data.findIndex(({ id }) => id === itemId);
                                    const newInitialIndex =
                                        currentItemIndex === data.length - 1 ? currentItemIndex - 1 : currentItemIndex;
                                    setState({
                                        initialId: newData?.[newInitialIndex]?.id,
                                        currentItemId: newData?.[newInitialIndex]?.id,
                                        // isUpdating: false,
                                    });
                                    setTimeout(() => setIsUpdating(false), 0);
                                }
                            }}
                        />
                    ) : (
                        <View
                            style={{
                                flex: 1,
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <LoadingIndicator/>
                        </View>
                    )}
                </View>
            </Page>
        );
    },
    { documents: { from: getDocuments } },
    { header: () => <AppHeader/> },
);
